import graphql__d223baa84d6288b41c91 from "./__generated__/DeleteAttributeDefinitionDialogMutation.graphql.ts";import * as React from "react";
import {useIntl} from "react-intl";
import {commitMutation, graphql} from "react-relay";
import Section from "../form/Section";
import Row from "../form/Row";
import FormDialog from "../dialog/FormDialog";
import type {DeleteAttributeDefinitionDialogMutation} from "./__generated__/DeleteAttributeDefinitionDialogMutation.graphql";
import {useRelayEnvironment} from "react-relay/hooks";
import Warning from "../presentational/Warning";
import {commitMutationWithErrorHandling} from "../../helper/commitMutationWithErrorHandling";
import {useErrorContext} from "../../contexts/ErrorContext";

type Props = {
    attributeDefinitionId: string;
    attributeName: string;
    handleCloseDialog: () => {};
}

const DeleteAttributeDefinitionDialog: React.FC<Props> = ({attributeDefinitionId, attributeName, handleCloseDialog}) => {
    const intl = useIntl();
    const relayEnvironment = useRelayEnvironment();
    const {addError} = useErrorContext();

    const handleSubmission = (input) => {
        commitMutationWithErrorHandling<DeleteAttributeDefinitionDialogMutation>(
            relayEnvironment,
            {
                mutation: graphql__d223baa84d6288b41c91,
                variables: {
                    input: {
                        id: attributeDefinitionId
                    }
                },
                updater: (store) => {
                    // Get the root query field that holds the attribute definitions connection
                    const root = store.getRoot();
                    const attributeDefinitionsConnection = root.getLinkedRecord('attributeDefinitions');

                    if (attributeDefinitionsConnection) {
                        const existingEdges = attributeDefinitionsConnection.getLinkedRecords('edges') || [];
                        // Remove the deleted attribute definition edge from the edges array
                        const updatedEdges = existingEdges.filter(
                            (edge) => {
                                const node = edge?.getLinkedRecord('node');
                                const id = node?.getValue('id');
                                return id !== attributeDefinitionId;
                            }
                        );
                        attributeDefinitionsConnection.setLinkedRecords(updatedEdges, 'edges');
                    }
                },
                onCompleted: (response, errors) => {
                    if (errors && errors.length > 0) {
                        console.error(errors);
                    }
                    handleCloseDialog();
                },
                onError: (error) => {
                    console.error(error);
                    handleCloseDialog();
                }
            },
            addError,
            {
                customErrorMessage: intl.formatMessage({id: 'errors.failedToDeleteAttributeDefinition'})
            }
        )
    }

    const initialValues = {
        id: attributeDefinitionId
    }

    return (
        <FormDialog
            handleCloseDialog={handleCloseDialog}
            handleSubmission={handleSubmission}
            initialValues={initialValues}
            headline={intl.formatMessage({id: 'dialog.DeleteAttributeDefinitionDialog.headline'})}
            submitLabel={intl.formatMessage({id: 'button.delete'})}
            dangerous={true}
        >
            <Section>
                <Row>
                    <p className="text-gray-900 font-medium">
                        {intl.formatMessage({id: 'dialog.DeleteAttributeDefinitionDialog.confirmMessage'}, {name: attributeName})}
                    </p>
                </Row>
                <Row>
                    <Warning>
                        {intl.formatMessage({id: 'dialog.DeleteAttributeDefinitionDialog.warning'})}
                    </Warning>
                </Row>
            </Section>
        </FormDialog>
    )
}

export default DeleteAttributeDefinitionDialog;
